/* eslint-disable @eslint-react/no-array-index-key */
import { useFormApi } from '@data-driven-forms/react-form-renderer';
import styled from '@emotion/styled';

import { Td, Tr } from '~/common/components/Tables';
import theme from '~/theme/';

const StyledTd = styled<any>(Td)`
  padding: 0;
  padding-left: 0.75rem;
  border-left: solid 1px ${(props) => props.theme.colors?.gray[200]};
`;

type TableRowProps = {
  fields?: any[];
  colSpan?: number[];
  sx?: any;
  headerCols?: {
    colSpan?: number;
  }[];
  tableRowSx?: any;
  hasNoLeftPadding?: boolean;
};

export default function TableRow({
  fields,
  sx = {},
  colSpan,
  headerCols,
  tableRowSx,
  ...rest
}: Readonly<TableRowProps>) {
  const { renderForm } = useFormApi();
  return (
    <Tr
      {...rest}
      sx={{
        '&:nth-of-type(even)': {
          background: tableRowSx?.background ?? theme?.colors?.bgGray[100],
        },
        alignItems: 'center',
        textAlign: 'center',
        ...tableRowSx,
      }}
    >
      {fields?.map((field, index) => (
        <StyledTd
          colSpan={colSpan ? colSpan[index] : headerCols[index].colSpan}
          key={index}
          sx={{
            paddingLeft: rest.hasNoLeftPadding
              ? sx.paddingLeft
              : (index > 0 && '1.75rem !important') || undefined,
            borderLeft: index === 0 ? undefined : '0px',
            ...sx,
          }}
        >
          {field && renderForm([field])}
        </StyledTd>
      ))}
    </Tr>
  );
}
